import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import Link from 'components/shared/link';

import HealthIcon from 'icons/health.inline.svg';
import EnterpriseIcon from 'icons/enterprise.inline.svg';
import ResidentialIcon from 'icons/residential.inline.svg';
import CommercialIcon from 'icons/commercial.inline.svg';
import TeamIcon from 'icons/team.inline.svg';
import ContactIcon from 'icons/contact.inline.svg';
import BlogIcon from 'icons/blog.inline.svg';
import CustomersIcon from 'icons/customers.inline.svg';
import EngineeringIcon from 'icons/engineering.inline.svg';
import SupportIcon from 'icons/support.inline.svg';
import PartnersIcon from 'icons/partners.inline.svg';
import PhoneIcon from 'icons/phone.inline.svg';
import VideoIntercomIcon from 'icons/video-intercom.inline.svg';
import CloudBasedIcon from 'icons/cloud-based.inline.svg';
import HardwareIcon from 'icons/hardware.inline.svg';
import MobileAccessIcon from 'icons/mobile-access.inline.svg';
import FaceRecognitionIcon from 'icons/face-recognition.inline.svg';
import DoorController4 from 'icons/door-controller-4.inline.svg';
import DoorController5 from 'icons/door-controller-5.inline.svg';
import SwiftReaderIcon from 'icons/swift-reader.inline.svg';
import ApartmentIcon from 'icons/apartment.inline.svg';
import OfficeIcon from 'icons/office.inline.svg';
import InstallIcon from 'icons/install.inline.svg';
import WebinarsIcon from 'icons/webinars.inline.svg';
import StudiesIcon from 'icons/studies.inline.svg';
import CheckIcon from 'icons/check.inline.svg';
import AccessControlIcon from 'icons/access-control.inline.svg';
import MobileAccessControlIcon from 'icons/mobile-access-control.inline.svg';
import TurnstilesIcon from 'icons/turnstiles.inline.svg';
import CentralStationIcon from 'icons/central-station.inline.svg';

import styles from './sub-menu-sections.module.scss';

const cx = classNames.bind(styles);

const icons = {
  health: HealthIcon,
  enterprise: EnterpriseIcon,
  residential: ResidentialIcon,
  commercial: CommercialIcon,
  team: TeamIcon,
  contact: ContactIcon,
  blog: BlogIcon,
  customers: CustomersIcon,
  engineering: EngineeringIcon,
  support: SupportIcon,
  partners: PartnersIcon,
  phone: PhoneIcon,
  videoIntercom: VideoIntercomIcon,
  cloudBased: CloudBasedIcon,
  hardware: HardwareIcon,
  mobileAccess: MobileAccessIcon,
  faceRecognition: FaceRecognitionIcon,
  doorController4: DoorController4,
  doorController5: DoorController5,
  swiftReader: SwiftReaderIcon,
  apartment: ApartmentIcon,
  office: OfficeIcon,
  install: InstallIcon,
  webinars: WebinarsIcon,
  studies: StudiesIcon,
  check: CheckIcon,
  accessControl: AccessControlIcon,
  mobileAccessControl: MobileAccessControlIcon,
  turnstiles: TurnstilesIcon,
  centralStation: CentralStationIcon,
};

const SubMenuSections = ({ className, items }) => {
  const numberOfColumns = `col-${items.length}`;
  return (
    <ul className={cx('wrapper', numberOfColumns, className)}>
      {items.map((item, index) => (
        <li className={cx('item')} key={index}>
          <ul className={cx('inner')}>
            <span className={cx('item-label')}>{item.label}</span>

            {item.childItems.nodes.map((itemSection, indexItemSection) => {
              const Icon = icons[itemSection.acf.iconName]
                ? icons[itemSection.acf.iconName]
                : icons.health;
              const withDescription = !!itemSection.description;

              return (
                <li key={indexItemSection}>
                  <Link className={cx('link', { withDescription })} to={itemSection.path}>
                    <Icon className={cx('icon')} />
                    <div>
                      <span className={cx('label')}>{itemSection.label}</span>
                      {withDescription && (
                        <p className={cx('description')}>{itemSection.description}</p>
                      )}
                    </div>
                  </Link>
                </li>
              );
            })}
          </ul>
        </li>
      ))}
    </ul>
  );
};

SubMenuSections.propTypes = {
  className: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      childItems: PropTypes.shape({
        nodes: PropTypes.arrayOf(
          PropTypes.shape({
            label: PropTypes.string.isRequired,
            path: PropTypes.string.isRequired,
            description: PropTypes.string,
            acf: PropTypes.shape({
              iconName: PropTypes.oneOf(Object.keys(icons)),
            }),
          })
        ),
      }).isRequired,
    })
  ).isRequired,
};

SubMenuSections.defaultProps = {
  className: null,
};

export default SubMenuSections;
